import { effectivePoTotalUsd, poHasInvoiceRecord } from "@/lib/manufacturing/purchaseOrderInvoice";
import { orderChargebackUsd } from "@/lib/manufacturing/purchaseOrderSpend";
import type { MfgPurchaseOrder } from "@/lib/manufacturing/purchaseOrderTypes";

function money(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return "—";
  return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
}

export function PurchaseOrderFinalRecord(props: { order: MfgPurchaseOrder }) {
  const { order } = props;
  const invoiced = poHasInvoiceRecord(order);
  const chargeback = orderChargebackUsd(order);
  const predicted = order.total ?? order.subtotal;
  return (
    <div className="rounded-lg border border-gray-200 px-3 py-2 text-[11px] dark:border-zinc-700">
      <div className="font-semibold text-gray-800 dark:text-zinc-100">Final record</div>
      <dl className="mt-1 grid grid-cols-2 gap-x-3 gap-y-1 text-gray-700 dark:text-zinc-300">
        <dt>PO {order.po_number}</dt>
        <dd>{order.status.replace(/_/g, " ")}</dd>
        <dt>Expected</dt>
        <dd>{money(predicted)}</dd>
        <dt>Invoice</dt>
        <dd>
          {invoiced
            ? `${money(effectivePoTotalUsd(order))}${
                order.invoice_pay_terms ? ` · ${order.invoice_pay_terms}` : ""
              }`
            : "waiting"}
        </dd>
        <dt>Chargebacks</dt>
        <dd>{money(chargeback)}</dd>
        <dt>Net accepted</dt>
        <dd>{money(effectivePoTotalUsd(order) - chargeback)}</dd>
      </dl>
      {(order.lines ?? []).length > 0 ? (
        <ul className="mt-2 space-y-1 border-t border-gray-100 pt-2 dark:border-zinc-800">
          {(order.lines ?? []).map((line) => (
            <li key={line.id}>
              {line.material_name}: ordered {line.quantity}
              {line.received_qty != null ? ` · received ${line.received_qty}` : " · not confirmed"}
              {line.quality_status && line.quality_status !== "pending"
                ? ` · ${line.quality_status.replace(/_/g, " ")}`
                : ""}
              {line.chargeback_usd != null && line.chargeback_usd > 0
                ? ` · chargeback ${money(line.chargeback_usd)}`
                : ""}
              {line.quality_note ? ` — ${line.quality_note}` : ""}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
